import React from "react";

export const LoginBranding: React.FC = () => {
  return (
    <div className="hidden lg:flex lg:w-1/2 relative bg-gradient-to-br from-teal-900 via-primary to-teal-800 p-12 text-white flex-col justify-between overflow-hidden">
      {/* Background Decorative Circles */}
      <div className="absolute -top-24 -left-24 w-96 h-96 bg-white/10 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-teal-400/20 rounded-full blur-3xl pointer-events-none" />

      {/* Top Section: App Brand */}
      <div className="relative z-10 flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center text-xl font-bold">
          🩺
        </div>
        <span className="text-xl font-bold tracking-wide">
          Ηρακλείδης ο Ταραντινός
        </span>
      </div>

      {/* Center Section: Hero Feature Highlights */}
      <div className="relative z-10 space-y-8 my-auto max-w-lg">
        <div className="space-y-4">
          <span className="px-3 py-1 text-xs font-semibold uppercase tracking-wider bg-white/10 border border-white/20 rounded-full text-teal-100">
            ΙΑΤΡΙΚΟ ΣΥΣΤΗΜΑ ΔΙΑΧΕΙΡΙΣΗΣ ΑΣΘΕΝΩΝ
          </span>
          <h1 className="text-4xl font-extrabold leading-tight">
            Ολοκληρωμένη φροντίδα & διαχείριση ασθενών.
          </h1>
          <p className="text-teal-100 text-base leading-relaxed">
            Πρόσβαση σε ιατρικούς φακέλους, ψηφιακές απεικονίσεις DICOM και
            στατιστικά στοιχεία με απόλυτη ασφάλεια.
          </p>
        </div>

        {/* Quick Feature Cards */}
        <div className="grid grid-cols-2 gap-4">
          <div className="p-4 rounded-xl bg-white/10 backdrop-blur-md border border-white/10">
            <div className="text-2xl mb-1">📋</div>
            <div className="font-semibold text-sm">Ηλεκτρονικός Φάκελος</div>
            <div className="text-xs text-teal-200 mt-1">
              Άμεση καταχώρηση & ιστορικό
            </div>
          </div>
          <div className="p-4 rounded-xl bg-white/10 backdrop-blur-md border border-white/10">
            <div className="text-2xl mb-1">🩻</div>
            <div className="font-semibold text-sm">DICOM Viewer</div>
            <div className="text-xs text-teal-200 mt-1">
              Προβολή ακτινογραφιών
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Section: Security Badge */}
      <div className="relative z-10 flex items-center gap-3 text-xs text-teal-200 border-t border-white/10 pt-6">
        <svg
          className="w-5 h-5 text-teal-300"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
          />
        </svg>
        <span>Υψηλά πρότυπα ασφαλείας & κρυπτογράφηση δεδομένων.</span>
      </div>
    </div>
  );
};